<template>
    <div class='ur-data-grid'>
        <!-- [AREA] Information area -->
        <grid-info/>
        <!-- [AREA] Table area -->
        <grid-table/>
        <!-- [AREA] Pagination area -->
        <!--
            $ver: v0.2.0
            사용자 지정 pagination을 사용할 수 있습니다.
            지정하지 않는 경우 기본 pagination을 사용합니다.
            #You can define custom pagination.
            #If you ain't set this slot, grid use default pagination.
        -->
        <slot name="pager">
            <grid-pager/>
        </slot>
        
        <template v-if="false">
            <!-- dummy_SlotManual
                 : 메뉴얼 작성용 영역입니다. 실제로 동작하지 않습니다.
                   v-if=false를 절대로 풀지 마세요. -->
            <!--
                $ver: v0.2.0
                상단의 왼쪽 정보영역에 대한 slot입니다.
                왼쪽의 total 정보등을 덮어 쓸 수 있습니다.
                #This slot is for left information section.
                #It overwrite default function "total row", "per page".
            -->
            <slot name="left-info"/>
            <!--
                $ver: v0.2.0
                상단의 정보영역중 가운데에 위치할 slot입니다.
                #This slot will be placed on center of information section.
            -->
            <slot name="center-info"/>
            <!--
                $ver: v0.2.0
                상단의 오른쪽 정보영역에 대한 slot입니다.
                #This slot is for right information section.
            -->
            <slot name="right-info"/>
            <!--
                $ver: v0.2.0
                상단의 왼쪽 명령영역에 대한 slot입니다.
                지정하지 않는 경우 보이지 않으며,
                정보영역이 있는경우 그 하단에 위치합니다.
                #This slot is for left action section.
                #If you don't active this option, It will invisible.
                #It overwrite default function "total row", "per page".
            -->
            <slot name="left-info"/>
            <!--
                $ver: v0.2.0
                상단의 오른쪽 정보영역에 대한 slot입니다.
                #This slot is for right information section.
            -->
            <slot name="right-info"/>
            <!--
                $ver: v0.2.1
                사용자 정의 헤더를 사용할 수 있습니다.
                #You can use user customized header.
            -->
            <slot name="header"/>
            <!--
                $ver: v0.2.1
                사용자 정의 페이지네이션을 사용할 수 있습니다.
                #You can use user customized pagination.
            -->
            <slot name="pager"/>
            <!--
                $ver: v0.2.1
                사용자 정의 아코디언 영역을 사용할 수 있습니다.
                #You can use user customized pagination.
            -->
            <slot name="accordion"/>
            <!--
                $ver: v0.2.1
                Summary 영역을 사용할 수 있습니다.
                #You can use user customized pagination.
            -->
            <slot name="summary"/>
        </template>
    </div>
</template>



<script>
// This component is only for "Interface" & "Description".
//      @see mixin/**/*mixin.js

// [IMPORT] Utils & Variables, mixins
import {dataMixin} from './mixin';
import {CONST_VALUE} from './config'

// [IMPORT] Sub components
import gridTable   from './common/urDataGridTable';
import gridInfo    from './info/urDataGridInfo';
import gridPager   from './pager/urDataGridPager';
export default {
    name : 'urDataGrid',
    mixins : [dataMixin],
    components : {gridInfo,gridPager,gridTable},
    props : {
        // $ver: v0.2.0
        // Data Grid를 위한 options 항목입니다.
        // options에 대한 상세 정보는..
        // #This props is options object for data grid.
        // #You'll be check about detail <b>options</b> attribute on...
        // $default: DEFAULT OPTIONS
        options : {type:Object},
        // $ver: v0.2.0
        // 그리드의 헤더(필드)정보 입니다. 각 필드에 대한 식별자와 이름, 유형정보 등을 관리합니다.
        // Columns에 대한 상세 정보는 하단을 확인해주세요.
        // #This props is for define headers(columns) infomation. It contains identifier, name, type and so on. 
        // #You'll be check about detail <b>columns</b> attribute on...
        headers : {type:[Array,Function], default: ()=>[]},
        // $ver: v0.2.0
        // DataSet 형태의 데이터를 입력받습니다.
        // Data source가 지정되면 items props은 무시됩니다.
        // #This props receives data which has DataSet type object. 
        // #When dataSource is setted, <b>Items</b> props will be ignored. 
        dataSource : {type:[Array,Object]},
        // $ver: v0.2.0
        // 데이터 전체 크기 입니다.
        // 페이지 처리등과 같이 입력된 데이터와 데이터 전체 크기가 다른 경우 입력해주세요.
        // #This props is for all data size.
        // #If data size is different with input data and entiry data.
        itemSize : {type:Number}
    },
    methods : {
        // @vuese
        // $ver: v0.2.0
        // $arg: value - Data for refresh(DataSet, Array only)
        // $return: N/A
        // 데이터를 갱신합니다.
        // #Set data to grid
        setData(v) {
            // [MIXIN] ./mixin/urDataGridMixin.js
            return this.mx_setData(v);
        },
        // @vuese
        // $ver: v0.2.0
        // $arg: value - Data for refresh(DataSet, Array only)
        // $return: N/A
        // 행의 데이터를 갱신합니다.
        // #Set data to grid row
        setRowValue(row, fil, val) {
            return this.mx_setValue(row, fil, val);
        },
        // @vuese
        // $ver: v0.2.1
        // $arg: value - Data for refresh(Array only)
        // $return: N/A
        // 데이터를 추가합니다.
        // #Append data to grid
        appendData(v) {
            // [MIXIN] ./mixin/urDataGridMixin.js
            return this.mx_appendData(v);
        },
        // @vuese
        // $ver: v0.2.1
        // $arg: value - Data for refresh(Array only)
        // $return: N/A
        // 데이터를 앞에서부터 추가합니다.
        // #Unshift data to grid
        unshiftData(v) {
            // [MIXIN] ./mixin/urDataGridMixin.js
            return this.mx_unshiftData(v);
        },
        // @vuese
        // $ver: v0.2.0
        // $return: 현재 데이터 목록
        // 원본 데이터를 조회합니다.
        // #Get raw grid data
        getData() {
            // [MIXIN] ./mixin/urDataGridMixin.js
            return this.mx_getRawData();
        },
        // @vuese
        // $ver: v0.2.0
        // $return: 현재 데이터 셋
        // 데이터 셋을 조회합니다.
        // #Get data set
        getDataSet() {
            // [MIXIN] ./mixin/urDataGridMixin.js
            return this.mx_dataSet;
        },
        // @vuese
        // $ver: v0.2.0
        // $return: 현재 데이터 목록
        // 현재 화면에 보여지는 데이터를 조회합니다.
        // (필터, 정렬 적용)
        // #Get data which current showing in grid
        // #Return Data is applied Sorting & Filtering.
        getViewData() {
            // [MIXIN] ./mixin/urDataGridMixin.js
            return this.mx_getViewData();
        },
        // @vuese
        // $ver: v0.2.0
        // $return: Header info
        // 내부에서 확장된 Header 정보를 가져옵니다.
        // #Get header info that expanded for grid logic
        getHeaders() {
            // [MIXIN] ./mixin/urCommonGridMixin.js
            return this.mx_fieldsInfo;
        },
        // @vuese
        // $ver: v0.2.0
        // $arg: value - Column information(Array)
        // $return: N/A
        // 컬럼 정보를 설정 합니다.
        // #Refresh column information
        setHeaders(v) {
            // [MIXIN] ./mixin/urCommonGridMixin.js
            this.mx_setHeaders(v);
        },
        // @vuese
        // $ver: v0.2.0
        // $return: Row Data witch selected
        // 선택된 데이터를 반환합니다.
        // #Get selected data
        getSelected() {
            // [MIXIN] ./mixin/data/urDataGridRowActMixin.js
            return this.mx_getSelected();
        },
        // @vuese
        // $ver: v0.2.0
        // 그리드에 선택된 항목을 리셋합니다.
        // #Reset selected
        resetSelect() {
            // [MIXIN] ./mixin/full/urFullGridRowActMixin.js
            this.mx_resetSelect();
        },
        // @vuese
        // $ver: v0.2.0
        // 그리드 알림기능입니다.
        // 그리드와 관련된 알림을 주고 싶을때 사용합니다.
        // #Notification feature of grid.
        // #Use this function, when noti about grid.
        noti(arg) {
            // [MIXIN] ./mixin/urCommonGridMixin.js
            this.mx_gridNoti(arg);
        },
        /**
         * @vuese
         * $ver: v0.2.0
         * $arg: maxTime Time(second) for blocker visible
         * 그리드의 로딩중 blocker를 호출합니다.
         * 테이블영역의 액션을 막습니다.
         * #Call loading blocker.
         * #It block action on table area.
         */
        loadingBlock(maxTime) {
            // [MIXIN] ./mixin/urCommonGridMixin.js
            this.mx_toggleBlock(true);
            if(maxTime) {
                setTimeout(()=> {
                    this.mx_toggleBlock(false);
                }, maxTime)
            }
        },
        // @vuese
        // $ver: v0.2.0
        // 그리드의 로딩중 blocker를 제거합니다.
        // #It release loading blocker.
        removeBlock() {
            // [MIXIN] ./mixin/urCommonGridMixin.js
            this.mx_toggleBlock(false);
        },
        // @vuese
        // $ver: v0.2.1
        // 그리드의 데이터를 csv로 export 합니다.
        // #Export grid data with csv format. 
        exportCsv(fileName) {
            // [MIXIN] ./mixin/urCommonGridMixin.js
            this.mx_exportCsvData(fileName);
        },
        // @vuese
        // $ver: v0.2.1
        // 수정된 데이터목록을 조회합니다.
        // 조회된 데이터는 객체 형식으로 {created, updated, removed}라는 이름의 배열로 반환됩니다.
        // #It returns changed data list.
        // #Return data is an object type which has created, updated, removed array.
        getChanged() {
            // [MIXIN] ./mixin/data/urDataGridRowActMixin.js
            return this.mx_getChanged();
        },
        // @vuese
        // $ver: v0.2.1
        // 수정된 데이터가 있는지 여부를 조회합니다.
        // #It return grid data is changed or not.
        isChanged() {
            // [MIXIN] ./mixin/data/urDataGridRowActMixin.js
            return this.mx_isChanged();
        },
        // @vuese
        // $ver: v0.2.1
        // 수정된 데이터의 정합성 여부를 체크합니다.
        // #Check changed data is valid or not.
        validChanged() {
            return this.mx_validChanged();
        },
        // @vuese
        // $ver: v0.2.1
        // $arg: Filter info. (Array & Object, Both types are OK)
        // 필터 정보를 입력하여 그리드 데이터에 적용합니다.
        // #Enter filter info and apply to grid data.
        filter(filter) {
            // [MIXIN] ./mixin/com/urCommonGridFilterMixin.js
            return this.mx_outerFilter(filter);
        },
        // @vuese
        // $ver: v0.2.1
        // $arg: Filter info. (Array & Object, Both types are OK)
        // 직접 필터를 적용하지는 않고, 외부에서 입력받은 필터 정보를 그리드에 반영합니다.
        // 값 동기화를 목적으로 활용됩니다.
        // #Apply filter infomation to grid. It doesn't fire filter action.
        // #Purpose of this methods is syncronize filter value inner & outer.
        syncFilter(filter) {
            // [MIXIN] ./mixin/com/urCommonGridFilterMixin.js
            return this.mx_syncFilter(filter);
        },
        // @vuese
        // $ver: v0.2.1
        // $arg: Flag, Apply view only or data filtering
        // 필터 정보를 초기화합니다. 플래그 속성을 통해 필터 정보(표시)만 초기화 할 수 있습니다.
        // #Reset filter info.
        // #You can use flag argument to reset viewing only.
        clearFilter(flag){
            // [MIXIN] ./mixin/com/urCommonGridFilterMixin.js
            if(flag) {
                return this.mx_syncFilter();
            } else {
                return this.mx_outerFilter();
            }
        },
        // @vuese
        // $ver: v0.2.1
        // $arg: Sort order. (Array)
        // 정렬 정보를 입력하여 그리드 데이터에 적용합니다.
        // #Enter sort order and apply to grid data.
        sort(sortOrder) {
            // [MIXIN] ./util/data/urDataGridSortMixin.js
            return this.mx_outerSort(sortOrder);
        },
        // @vuese
        // $ver: v0.2.1
        // $arg: Sort order. (Array)
        // 정렬 정보를 입력하여 그리드의 화면에만 표시합니다.
        // 실제로 정렬 정보를 반영하지는 않습니다.
        // #Inject sort order and apply to grid viewing.
        // #It's not applied to grid data(data sorting).
        syncSort(sortOrder) {
            // [MIXIN] ./util/data/urDataGridSortMixin.js
            return this.mx_syncSort(sortOrder);
        },
        // @vuese
        // $ver: v0.2.1
        // $arg: Flag, Apply view only or data sorting
        // 정렬 정보를 초기화합니다. 플래그 속성을 통해 정렬 정보(표시)만 초기화 할 수 있습니다.
        // #Reset sorting.
        // #You can use flag argument to reset viewing only.
        clearSort(flag){
            // [MIXIN] ./util/data/urDataGridSortMixin.js
            if(flag) {
                return this.mx_syncSort();
            } else {
                return this.mx_outerSort();
            }
        },
        
        // @vuese
        // $ver: v0.2.1
        // $arg: num, Number of scroll position(px)
        // 컨텐츠 영역의 세로 스크롤 위치를 지정합니다.
        // #Set top position of vertical scroll
        setScrollTop(number) {
            // [EVENT] ./content/wrapper/mixin/urDataGridContentWrapperMixin.js
            this.mx_ebusEmit('set-scroll-top',number)
        },
        // @vuese
        // $ver: v0.2.1
        // $arg: num, Number of scroll position(px)
        // 컨텐츠 영역의 가로 스크롤 위치를 지정합니다.
        // #Set top position of horizontal scroll
        setScrollLeft(number) {
            // [EVENT] ./content/wrapper/mixin/urDataGridContentWrapperMixin.js
            this.mx_ebusEmit('set-scroll-left',number)
        },
        // @vuese
        // $ver: v0.2.1
        // $arg: fieldKey, The key of field. 
        // 컨텐츠 영역의 가로 스크롤 위치를 지정한 필드의 위치로 이동시킵니다.
        // #Set left scroll to field's location.
        setScrollField(fieldKey) {
            // [MIXIN] ./mixin/urCommonGridMixin.js
            this.mx_setScrollField(fieldKey);
        },
        // @vuese
        // $ver: v0.2.1
        // $arg: rowIdx, The index of row for scroll to.
        // 컨텐츠 영역의 세로 스크롤 위치를 지정한 행의 위치로 이동시킵니다.
        // #Set top scroll to row's index.
        setScrollRow(rowIdx) {
            // [MIXIN] ./mixin/urCommonGridMixin.js
            this.mx_setScrollRow(rowIdx);
        },
        // @vuese
        // $ver: v0.2.1
        // $arg: (optional) v, Information object of grid options.
        // 그리드 옵션을 갱신합니다.
        // 매개변수가 없는 경우 기존 입력된 값을 재활용합니다.
        // #Refresh grid options
        // #If you don't set arguments, re-use previous value.
        updateOptions(v) {
            // [MIXIN] ./mixin/urCommonGridMixin.js
            this.mx_buildOptions(v||this.options);
        },
        // @vuese
        // $ver: v0.2.1
        // $arg: (optional) v, Array of headers
        // 헤더(필드) 옵션을 갱신합니다.
        // 매개변수가 없는 경우 기존 입력된 값을 재활용합니다.
        // #Refresh header infomations
        // #If you don't set arguments, re-use previous value.
        updateHeaders(v) {
            // [MIXIN] ./mixin/urCommonGridMixin.js
            this.mx_setHeaders(v||this.headers)
        },
        // @vuese
        // $ver: v0.2.1
        // $arg: (optional) v, Array of headers
        // 지정된 헤더(필드)의 옵션을 갱신합니다.
        // #Refresh specific header infomations
        // #If you don't set arguments, re-use previous value.
        setHeaderAttr(field, attr, value) {
            // [MIXIN] ./mixin/urCommonGridMixin.js
            this.mx_setHeaderAttr(field, attr, value)
        },
        /**
         * @vuese
         * $ver: v0.2.2
         * $arg: Array of error-message
         * 밖에서 검증한 에러 메시지 내용을 그리드에 반영합니다.
         * 데이터는 배열의 형태로 입력 받으며 배열의 각 객체는
         * "__id" 필드값을 통해 대상 데이터를 식별하고,
         * 각 속성별로 에러 메시지를 설정합니다.
         * #Apply error-message that validate result on outer grid
         * #Argument has to be array, and each object in array has to fallow this rules
         * #"__id" filed is mandatory, and that value means which row will be validate.
         * #Other fields is optional, and Error-message of that field will be here.
         */
        setErrorMessages(msgArr) {
            this.mx_setErrMsg(msgArr)
        },
        /**
         * @vuese
         * $ver: v1.0.1
         * $arg: rowId - Row ID
         * $arg: fieldkey - Field key(value)
         * $arg: text - Error message
         * $arg: _type - type of message(optional, default:error)
         * 지정한 셀에 메시지를 추가합니다.
         * #Append message to target cell.
         */
        setErrorMessage(rowId, fieldKey, text, _type) {
            this.mx_setErrMsg(rowId, fieldKey, text, _type)
        },
        /**
         * @vuese
         * $ver: v1.0.1
         * $arg: rowId - Row ID(optional)
         * $arg: fieldkey - Field key(optional)
         * 메시지를 삭제합니다.
         * fieldKey를 넣지 않는경우 row 전체를, rowId와 fieldKey를 넣지 않는 경우 전체 그리드의 메시지를 삭제합니다.
         * #Remove grid message.
         */
        resetErrorMessage(rowId, fieldKey) {
            this.mx_resetErrMsg(rowId, fieldKey)
        },
        /**
         * @vuese
         * $ver: v1.0.1
         * 헤더 정보를 변경할수 있는 콘텍스트 팝업을 호출합니다.
         * #Open context popup that can Change header info.
         */
        openHeaderConfig() {
            this.mx_openHeaderConfig();
        },
        /**
         * @vuese
         * $ver: v1.0.1
         * 그리드의 페이지를 지정된 위치로 이동시킵니다.
         * #Move grid page index.
         */
        setCurrentPage(idx) {
            this.mx_setCurrPage(idx);
        },
        /**
         * @vuese
         * $ver: v1.0.1
         * 그리드의 페이지를 초기화(1) 시킵니다.
         * #Initialize grid page index(to 1).
         */
        initCurrentPage(idx) {
            this.setCurrentPage(1);
        },
        // @vuese
        // $ver: v0.2.1
        // 그리드를 초기화 합니다.(정렬, 필터, 옵션 등...)
        // #Initialize grid, (ex Sort, Filter, Options...)
        initGrid() {
            // 1. Reset data
            this.updateOptions()
            this.updateHeaders()
            this.clearSort()
            this.clearFilter()
            this.resetSelect()
            this.mx_resetFocus()
            // 2. Re-build data
            this.mx_buildData();
        },
        // CAUTION!!! 사용하지 마시오. 이벤트 설명용 함수
        dummy_EventManual() {
            // 셀을 클릭했을때의 이벤트입니다.
            // #Click event for cell
            // $arg: Value of cell
            // $arg: Data object of clicked row
            // $arg: Field information
            // $arg: Native click event
            this.$emit('grid:click');
            // 행을 클릭했을때의 이벤트입니다.
            // #Click event for row
            // $arg: Data object of clicked row
            // $arg: Native click event
            this.$emit('grid:row-click');
            // 데이터가 정렬 되었을때 호출되는 이벤트
            // #It fire when grid data is sorted
            // $arg: Sort order(array)
            // $tags: Sort
            this.$emit('grid:sorted');
            // 데이터가 필터(검색) 되었을때 호출되는 이벤트
            // 배열 정보의 순서는 결과와 상관 없습니다.
            // #It fire when grid data is filtered
            // #The order of array info is independent of the result.
            // $arg: Filter info.(array)
            // $tags: Filter
            this.$emit('grid:filtered');
            // 페이지네이션 관련 정보가 변경되었을때 호출되는 이벤트
            // 페이지 변경, 페이지 크기 변경 등
            // #It fires when change info. about pagination
            // #ie. current page, page size...
            // $arg: Pagination object {rowsPerPage, currentPage, totalPages, totalItems}
            // $tags: Pagination
            this.$emit('grid:paging',pager);
            // 추가(Add) 버튼을 클릭했을때 호출되는 이벤트
            // #It fires when click "Add" button on grid action bar.
            // $tags: Edit
            this.$emit('grid:btn-add');
            // 수정(Modify) 버튼을 클릭했을때 호출되는 이벤트
            // #It fires when click "Modify" button on grid action bar.
            // $tags: Edit
            this.$emit('grid:btn-modify');
            // 취소(Cancel) 버튼을 클릭했을때 호출되는 이벤트
            // #It fires when click "Cancel" button on grid action bar.
            // $tags: Edit
            this.$emit('grid:btn-cancel');
            // 삭제(Delete) 버튼을 클릭했을때 호출되는 이벤트
            // 선택된 행을 삭제한다.
            // #It fires when click "Delete" button on grid action bar.
            // #This removes selected row from origin data.
            // $arg: Removed data array.
            // $arg: Selected data count.
            // $tags: Edit
            this.$emit('grid:btn-delete');
            // 저장(Save) 버튼을 클릭했을 때 호출되는 이벤트
            // 값이 수정 또는 추가(생성) 되었을 때에 호출된다.
            // #It fires when click "Save" button on grid action bar.
            // #You can see this on created and updated an item(row).
            // $arg: Saved item data
            // $tags: Edit
            this.$emit('grid:btn-save'   ,rows);
            // 값이 수정되었을 때에 발생하는 이벤트
            // 추가/수정/삭제이벤트와 함께 발생한다.
            // #It fires when some data are changed.
            // #It contains create/update/delete .
            // $arg: Changed info. The object which contains created/updated/removed array. ex) {created:[...], updated:[...], removed:[...]}
            // $tags: Edit
            this.$emit('grid:data-changed',changed);
            // Row의 선택용 체크박스를 클릭했을 때의 이벤트
            // #Click event for checkbox in row first column checkbox
            // $arg: Data object of clicked row
            // $arg: Native click event
            this.$emit('grid:check-click', selected, $evt);
            // 그리드(컨텐츠 영역)의 사이즈가 변경되었을때 발생하는 이벤트
            // #Event when resize grid(contents area)
            // $arg: Size of width
            // $arg: Native click event
            this.$emit('grid:resize', width, height);
            // 그리드의 선택 정보가 변경되었을 때에 발생하는 이벤트
            // #Event when changed selected row
            // $arg: Selected rows
            this.$emit('grid:selected', selected);
            // 그리드의 행을 더블클릭 하였을 때에 발생하는 이벤트
            // #Event when double clicked row
            // $arg: Clicked row
            // $arg: Dbl-Click event
            this.$emit('grid:row-dbl-click', row, e);
            // 그리드의 스크롤이 최상단일 때 발생하는 이벤트
            // #Event that occurs when the grid scrolls to the top
            this.$emit('grid:scroll-top');
            // 그리드의 스크롤이 최하단일 때 발생하는 이벤트
            // #Event that occurs when the grid scrolls to the bottom
            this.$emit('grid:scroll-bottom');
        }
    },
    provide() {
        // [MIXIN] ./util/urDataGridMixin.js
        return {gridInfo:this.mx_sharedData, cellSelect:{}, rowInfo:{}, groupNode:{}};
    },
    computed: {
        // [COMPUTED][SHARE] Variable & Function for share with sub components
        mx_sharedData() { /* Data for grid -> provide */
            let rtn = {}, odf = Object.defineProperty;
            // tools
            odf(rtn, 'dataSet', {get:()=>this.mx_dataSet});
            odf(rtn, 'updated', {get:()=>this.mx_dataSet.updated});
            odf(rtn, 'caller' , {get:()=>this.mx_caller}); // WARN
            // data
            odf(rtn, 'gridData', {get:()=>this.mx_dataSet.data});
            // variables
            odf(rtn, 'full'  , {get:()=>false});
            odf(rtn, 'cols'  , {get:()=>this.mx_fieldsInfo});
            odf(rtn, 'fmap'  , {get:()=>this.mx_fieldMap});
            odf(rtn, 'opts'  , {get:()=>this.mx_options});
            odf(rtn, 'data'  , {get:()=>this.mx_getViewData()});
            odf(rtn, 'eventBus'  , {get:()=>this.mx_eventBus});
            odf(rtn, 'dataCols'  , {get:()=>this.mx_dataFields});
            odf(rtn, 'freezeCols', {get:()=>this.mx_freezeFields});
            odf(rtn, 'focusRow'  , {get:()=>this.mx_focused});
            
            odf(rtn, 'sels'  , {get:()=>this.mx_dataSet.getSelected()});
            odf(rtn, 'fils'  , {get:()=>this.mx_filtered});
            odf(rtn, 'refs'  , {get:()=>this.mx_refs})
            odf(rtn, 'pager' , {get:()=>this.mx_pager});
            odf(rtn, 'notis' , {get:()=>this.mx_notiArr});
            odf(rtn, 'slot'  , {get:()=>this.$scopedSlots});
            // vars...
            odf(rtn, 'vars_dataSize'     , {get:()=>this.vars_dataSize});
            odf(rtn, 'vars_viewSize'     , {get:()=>this.vars_viewSize});
            odf(rtn, 'vars_tableWidth'   , {get:()=>this.vars_tableWidth});
            odf(rtn, 'vars_keyField'     , {get:()=>this.vars_keyField});
            odf(rtn, 'vars_windowRow'    , {get:()=>this.vars_windowRow});
            odf(rtn, 'vars_freezeWidth'  , {get:()=>this.vars_freezeWidth});
            odf(rtn, 'vars_freezeCount'  , {get:()=>this.vars_freezeCount});
            odf(rtn, 'vars_selLen'       , {get:()=>this.vars_selLen});
            odf(rtn, 'vars_headerContext', {get:()=>this.vars_headerContext});
            odf(rtn, 'vars_currEditRow'  , {get:()=>this.vars_currEditRow});
            odf(rtn, 'vars_onCreating'   , {get:()=>this.vars_onCreating});
            odf(rtn, 'vars_onBlocking'   , {get:()=>this.vars_onBlocking});
            odf(rtn, 'vars_resizeGuide'  , {get:()=>this.vars_resizeGuide});
            odf(rtn, 'vars_accordionRow' , {get:()=>this.vars_accordionRow});
            odf(rtn, 'vars_accordionVert', {get:()=>this.vars_accordionVert});
            //     - Cell Action...
            odf(rtn, 'vars_cSelOnDrag'  , {get:()=>this.mx_cSelOnDrag});
            odf(rtn, 'vars_cSelOnSelect', {get:()=>this.mx_cSelOnSelect});
            odf(rtn, 'vars_cSelIdxSt'   , {get:()=>this.mx_cSelIdxSt});
            odf(rtn, 'vars_cSelFilSt'   , {get:()=>this.mx_cSelFilSt});
            odf(rtn, 'vars_cSelIdxEd'   , {get:()=>this.mx_cSelIdxEd});
            odf(rtn, 'vars_cSelFilEd'   , {get:()=>this.mx_cSelFilEd});
            odf(rtn, 'vars_cSelOnEdit'  , {get:()=>this.mx_cSelOnEdit});
            odf(rtn, 'vars_cTempValue'  , {get:()=>this.mx_cTempValue});
            odf(rtn, 'vars_cOnFlotage'  , {get:()=>this.mx_cOnFlotage});
            //     - Copy!!
            odf(rtn, 'vars_cClipboard'  , {get:()=>this.mx_cClipboard});
            //     - Message(urCommonGridMixin.js)
            odf(rtn, 'vars_messages'    , {get:()=>this.vars_messages});
            // Const value...
            odf(rtn, 'CONST', {get:()=>CONST_VALUE});
            // methods
            odf(rtn, 'func' , {get:()=>{return {
                // urCommonGridMixin.js
                'fireEvent'        : this.mx_fireEvent,
                'getField'         : this.mx_getField,
                'setRefs'          : this.mx_setRefs,
                'setHeaderContext' : this.mx_setHeaderCtx,
                'setFieldWidth'    : this.mx_setFieldWidth,
                'gridNoti'         : this.mx_gridNoti,
                'toggleBlock'      : this.mx_toggleBlock,
                'resizerPos'       : this.mx_setResizerPos,
                'openContext'      : this.mx_openContext,
                'recalcWidth'      : this.mx_recalcFieldWidth,
                
                'addCellMsg'       : this.mx_addCellMsg,
                'delCellMsg'       : this.mx_delCellMsg,
                // urCommonGridCellActMixin.js
                'isSelectedCell'   : this.mx_isSelectedCell,
                'startCellSelect'  : this.mx_startCellSelect,
                'endCellSelect'    : this.mx_endCellSelect,
                'clearCellSelect'  : this.mx_clearCellSelect,
                'selectAllData'    : this.mx_selectAllData,
                'startCellDrag'    : this.mx_startCellDrag,
                'finishCellDrag'   : this.mx_finishCellDrag,
                
                'moveCellSelect'   : this.mx_cellSelectKeyEvent,
                'setCellFlotage'   : this.mx_setCellFlotage,
                
                'editCell'         : this.mx_editCell,
                'saveCell'         : this.mx_saveCell,
                'cancelCell'       : this.mx_cancelCell,
                'cellTempValue'    : this.mx_setCellTempValue,
                'deleteCellData'   : this.mx_deleteCellData,
                // urCommonGridCopyMixin.js
                'getCopyData'      : this.mx_getCopyData,
                'setPasteData'     : this.mx_setPasteData,
                'copyToClipboard'  : this.mx_copyToClipboard,
                'clearClipboard'   : this.mx_clearClipboard,
                // urDataGridMixin.js
                'buildData'        : this.mx_buildData,
                'buildViewData'    : this.mx_buildViewData,
                'openAccordion'    : this.mx_openAccordion,
                'groupTreeOffset'  : this.mx_buildGroupTreeOffset,
                'setRowValue'      : this.mx_setValue,
                // urDataGridRowActMixin.js
                'setSelect'        : this.mx_setSelect,
                'setFocus'         : this.mx_setFocus,
                'setRangeSelect'   : this.mx_setRangeSelect,
                'selectAll'        : this.mx_selectAll,
                'resetSelect'      : this.mx_resetSelect,
                
                'toggleRowModify'  : this.mx_toggleRowModify,
                'toggleRowSaved'   : this.mx_toggleRowSaved,
                'toggleEditCancel' : this.mx_toggleEditCancel,
                'removeRows'       : this.mx_removeRows,
                'addEmptyRow'      : this.mx_addEmptyRow,
                'createNewRow'     : this.mx_createNewRow,
                'createEmptyRow'   : this.mx_createEmptyRow,
                // urDataGridSortMixin.js
                'toggleSortField'  : this.mx_sort_toggleField,
                // urCommonGridFilterMixin.js
                'buildFilter'      : this.mx_buildFilter
            }}});
            
            return rtn;
        }
    }
}
</script>


